import React, { FC, useState } from 'react';
import styles from './recruiterLanding.module.less';
import { Title } from '../../../components/Typogrphy/Title';
import { Button } from 'antd';
import Image from 'next/image';
import { PlusOutlined, RightOutlined } from '@ant-design/icons';
import ML from '../../../public/recruiter/recruiter-landing/ML.svg';
import BlockChain from '../../../public/recruiter/recruiter-landing/BlockChain.svg';
import AI from '../../../public/recruiter/recruiter-landing/AI.svg';
import PlayBtn from '../../../public/recruiter/recruiter-landing/PlayBtn.svg';

import background from '../../../public/recruiter/recruiter-landing/featuresimage.png';
// import RecruiterCreateModal, {
//   RecruiterCreateModalInstance,
// } from '../../Recruiiter/RecruiterCreateModal';
import { useRouter } from 'next/router';
import { CandidateHomeData } from '../../home/HomePage';
import { TestimonialView } from '../../../components/TestimonialView/TestimonialView';
type Props = {
  data?: any;
};
export const RecruiterTestimonialsBanner: FC<Props> = (props) => {
  // const ref = useRef<RecruiterCreateModalInstance>(null);
  const [guestData, setGuestData] = useState(props.data);
  const history = useRouter();
  return (
    <section
      className={`relative w-screen self-center flex justify-center mt-[-20px] bg-[#f6fbfa] text-[#050931] ${styles.SectioCont}`}>
      <div
        className={`w-full max-w-[1600px] px-[20px] md:px-[65px] py-[40px] flex items-center z-10 flex-col lg:flex-row gap-8 lg:gap-0 ${styles.ImageMob}`}>
        <div className={styles.testimonialsContainer}>
          <div className={styles.recruiterRow} style={{ marginBottom: '50px' }}>
            <div className={styles.RowContainer}>
              <Title level={1} style={{ textAlign: 'center', marginTop: 0 }}>
                Testimonials
              </Title>
              <div style={{ width: '100%', alignSelf: 'center' }}>
                <div className={styles.testimonialView}>
                  {guestData && <TestimonialView guestrec={true} items={guestData} />}
                </div>
              </div>
              <div className={styles.btnContainer} style={{ alignSelf: 'center' }}>
                <Button
                  type={'primary'}
                  onClick={() => history.push('/view-testimonials')}
                  className={styles.testimonialbtnPrimary}>
                  View All
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
